import { __require as requireReactIs } from '../node_modules/react-is/index.mjs';

var reactIsExports = /*@__PURE__*/ requireReactIs();

export { reactIsExports as r };
//# sourceMappingURL=index8.mjs.map
